<template>
	<div>
		<Breadcrumbs main="Support Management" title="API Requesters" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<button class="btn btn-primary float-end" type="button" @click="openCreateModal">Create Requester</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchRequesters()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-4 mt-2">
										<input type="text" class="form-control" placeholder="Search name / mobile" v-model="keyword" @keyup="fetchRequesters()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="api-requesters-table">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Name</th>
											<th>Mobile</th>
											<th>Created At</th>
											<th>Options</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(requesters.length)">
										<tr v-for="(item, index) in requesters" :key="item.id" align="center">
											<td>{{ from + index }}</td>
											<td>{{ item.name }}</td>
											<td>{{ item.phone }}</td>
											<td>{{ item.created_at ? $filters.formatDateTime(item.created_at) : '-' }}</td>
											<td>
												<button class="btn btn-sm btn-primary me-1 mb-1" type="button" @click="showAccessUrl(item)">Show URL</button>
												<button class="btn btn-sm btn-secondary me-1 mb-1" type="button" @click="downloadDocumentation(item)">Download PDF</button>
												<router-link :to="{ name: 'api_requester_logs', params: { id: item.id } }" class="btn btn-sm btn-secondary mb-1">Access Logs</router-link>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="5" align="center">No API requesters found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<caption v-if="Boolean(requesters.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{ from }} to {{ to }} of {{ total }} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li
										class="page-item"
										v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
										v-for="(page, index) in pagination"
										:key="page.label"
									>
										<a class="page-link" href="#" @click.prevent="fetchRequesters(buildQueryString(page.url))" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal title="Create API Requester">
			<template #body>
				<form @submit.prevent="createRequester">
					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Name<span class="text-danger">*</span></label>
							<input class="form-control" v-model="form.name" type="text" placeholder="Enter name" />
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Mobile<span class="text-danger">*</span></label>
							<input class="form-control" v-model="form.mobile" v-mobile-limit type="text" placeholder="Enter mobile" maxlength="10" minlength="10" />
						</div>
					</div>
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="submitting">
							<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							{{ submitting ? 'Saving...' : 'Save' }}
						</button>
						<button type="button" class="btn btn-light" @click="closeCreateModal" :disabled="submitting">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		<div class="modal fade" id="requesterUrlModal" tabindex="-1" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Access URL{{ selectedRequester ? ' - ' + selectedRequester.name : '' }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<label class="control-label mb-2">Share this URL with the requester. Replace keyword with vehicle number or IMEI.</label>
						<textarea class="form-control" rows="3" readonly>{{ accessUrl }}</textarea>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" @click="copyAccessUrl">Copy URL</button>
						<button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from 'bootstrap';
import DynamicModal from '@/components/dynamic_modal.vue';

export default {
	name: 'ApiRequesters',
	components: {
		DynamicModal,
	},
	data() {
		return {
			token: '',
			user: null,
			requesters: [],
			pagination: [],
			listing_length: 10,
			keyword: '',
			from: 0,
			to: 0,
			total: 0,
			submitting: false,
			form: {
				name: '',
				mobile: '',
			},
			selectedRequester: null,
			accessUrl: '',
			createModal: null,
			urlModal: null,
			productionBaseUrl: 'https://api.airotrack.in',
		};
	},
	mounted() {
		this.createModal = new Modal(document.getElementById('dynamicmodal'));
		this.urlModal = new Modal(document.getElementById('requesterUrlModal'));
		this.fetchRequesters();
	},
	methods: {
		getToken() {
			if (localStorage.getItem('airotrack_staff')) {
				const airotrack_staff = JSON.parse(localStorage.getItem('airotrack_staff'));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
					this.user = airotrack_staff;
				} else {
					this.$swal('', 'Failed to fetch token, please login again', 'error');
					this.$router.push({ name: 'login' });
				}
			} else {
				this.$swal('', 'Session expired, please login again', 'error');
				this.$router.push({ name: 'login' });
			}
		},
		buildQueryString(baseUrl = null) {
			const params = new URLSearchParams();
			params.append('limit', this.listing_length);
			if (this.keyword && this.keyword.trim()) {
				params.append('keyword', this.keyword.trim());
			}
			if (baseUrl) {
				const separator = baseUrl.includes('?') ? '&' : '?';
				return baseUrl + separator + params.toString();
			}
			return '/staffs/apiRequesters?' + params.toString();
		},
		fetchRequesters(page_url = null) {
			this.getToken();
			page_url = page_url || this.buildQueryString();
			this.$axios
				.get(page_url, { headers: { Authorization: 'Bearer ' + this.token } })
				.then((res) => {
					const responseData = res.data.data || {};
					const page = responseData.requesters || {};
					this.requesters = page.data || [];
					this.pagination = page.links || [];
					this.from = page.from || 0;
					this.to = page.to || 0;
					this.total = page.total || 0;
				})
				.catch((err) => {
					this.$swal('Error', this.$getApiErrorMessage?.(err, 'Failed to load API requesters') || 'Failed to load API requesters', 'error');
				});
		},
		openCreateModal() {
			this.form = { name: '', mobile: '' };
			this.createModal?.show();
		},
		closeCreateModal() {
			this.createModal?.hide();
		},
		createRequester() {
			if (this.submitting) return;
			this.submitting = true;
			this.getToken();
			this.$axios
				.post(
					'/staffs/addApiRequester',
					{
						name: this.form.name,
						mobile: this.form.mobile,
					},
					{ headers: { Authorization: 'Bearer ' + this.token } }
				)
				.then((res) => {
					if (res.data.status == true || res.data.status === 'true') {
						this.$swal('', res.data.message || 'API requester created successfully', 'success');
						this.closeCreateModal();
						this.fetchRequesters();
					} else {
						this.$swal('', res.data.message || 'Failed to create requester', 'error');
					}
				})
				.catch((err) => {
					this.$swal('Error', this.$getApiErrorMessage?.(err, 'Failed to create requester') || 'Failed to create requester', 'error');
				})
				.finally(() => {
					this.submitting = false;
				});
		},
		buildAccessUrl(uniqueToken) {
			const base = String(this.productionBaseUrl || 'https://api.airotrack.in').replace(/\/+$/, '');
			return `${base}/api/vehicle-live-data?token=${uniqueToken}&keyword={{vehicle_no/imei}}`;
		},
		showAccessUrl(requester) {
			this.selectedRequester = requester;
			this.accessUrl = this.buildAccessUrl(requester.unique_token);
			this.urlModal?.show();
		},
		copyAccessUrl() {
			if (!this.accessUrl) return;
			navigator.clipboard.writeText(this.accessUrl).then(
				() => this.$swal('', 'URL copied', 'success'),
				() => this.$swal('', 'Failed to copy URL', 'error')
			);
		},
		downloadDocumentation(requester) {
			this.getToken();
			this.$axios
				.get('/staffs/apiRequestersDocumentation', {
					params: { requester_id: requester.id },
					headers: { Authorization: 'Bearer ' + this.token },
					responseType: 'blob',
				})
				.then((res) => {
					const blob = new Blob([res.data], { type: 'application/pdf' });
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					const safeName = String(requester.name || 'requester').replace(/[^A-Za-z0-9_-]+/g, '_');
					link.download = `API_Requesters_Documentation_${safeName}.pdf`;
					document.body.appendChild(link);
					link.click();
					link.remove();
					window.URL.revokeObjectURL(url);
				})
				.catch((err) => {
					this.$swal('Error', this.$getApiErrorMessage?.(err, 'Failed to download documentation') || 'Failed to download documentation', 'error');
				});
		},
	},
};
</script>

<style>
@import '@/assets/css/custom.css';
</style>
